module.exports = __webpack_public_path__ + "static/media/Hotel Montana Luzern rund.876490c0.png";